import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCogs, FaAngleDown } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ControlPanel = ({ showControlPanel, setShowControlPanel, currencies, selectedCurrency, setSelectedCurrency }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="mb-6 overflow-hidden rounded-xl shadow-sm"
    >
      <button
        onClick={() => setShowControlPanel(!showControlPanel)}
        className="w-full flex items-center justify-between p-4 bg-white dark:bg-gray-800 rounded-xl border-b border-gray-100 dark:border-gray-700 text-left group transition-all"
        style={{ borderBottomLeftRadius: showControlPanel ? 0 : undefined, borderBottomRightRadius: showControlPanel ? 0 : undefined }}
      >
        <div className="flex items-center">
          <motion.div 
            animate={{ rotate: showControlPanel ? 180 : 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="w-8 h-8 mr-3 flex items-center justify-center rounded-lg bg-indigo-100 dark:bg-indigo-900/50 text-indigo-600 dark:text-indigo-400"
          >
            <FaCogs className="w-4 h-4" />
          </motion.div>
          <div>
            <span className="font-medium text-gray-800 dark:text-gray-200">Analysis Settings</span>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Customise your financial calculations</p>
          </div>
        </div>
        <motion.div 
          animate={{ 
            rotate: showControlPanel ? 180 : 0,
            backgroundColor: showControlPanel ? "rgb(79, 70, 229)" : "rgb(243, 244, 246)",
          }}
          transition={{ 
            type: "spring", 
            stiffness: 300, 
            damping: 20 
          }}
          className="h-8 w-8 flex items-center justify-center rounded-lg dark:bg-gray-700 transition-colors"
        >
          <FaAngleDown className={showControlPanel ? "text-white dark:text-white" : "text-gray-500 dark:text-gray-400"} />
        </motion.div>
      </button>
      
      <AnimatePresence>
        {showControlPanel && (
          <motion.div
            key="content"
            initial={{ opacity: 0, height: 0 }}
            animate={{ 
              opacity: 1, 
              height: "auto",
              transition: {
                height: {
                  type: "spring",
                  stiffness: 300,
                  damping: 30
                },
                opacity: { duration: 0.2 }
              }
            }}
            exit={{ 
              opacity: 0, 
              height: 0,
              transition: {
                height: { duration: 0.2 },
                opacity: { duration: 0.1 }
              }
            }}
            className="bg-white dark:bg-gray-800 rounded-b-xl overflow-hidden"
          >
            <motion.div
              initial={{ y: -20 }}
              animate={{ y: 0 }}
              exit={{ y: -20 }}
              transition={{ type: "spring", stiffness: 300, damping: 25, delay: 0.05 }}
              className="p-4 space-y-6 divide-y divide-gray-100 dark:divide-gray-700"
            >
              {/* Currency Selection */}
              <div className="pt-0 pb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Currency
                </label>
                <div className="flex flex-wrap gap-2">
                  {currencies.map(currency => (
                    <button
                      key={currency}
                      onClick={() => {
                        if (currency !== selectedCurrency) {
                          setSelectedCurrency(currency);
                          toast.info(`Currency changed to ${currency}`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          });
                        }
                      }}
                      className={`px-3 py-2 rounded-md text-sm transition-all ${
                        selectedCurrency === currency
                          ? 'bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300 font-medium ring-1 ring-indigo-300 dark:ring-indigo-700'
                          : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                      }`}
                    >
                      {currency}
                    </button>
                  ))}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ControlPanel;
